import type { FC } from 'react'

import Image from '@segment/matcha/components/Image'

import type { Media } from '@segment/api/types/templates/base'

const TemplateImage: FC<Media> = ({ src, title, width, height }) => (
  <picture>
    <source type="image/webp" src={`${src}`} />
    <Image src={src} alt={title} width={width} height={height} loading="lazy" />
  </picture>
)

export default TemplateImage
